import { type FC } from 'react'
import { useDynamicsBasedContactSync } from '../IntegrationSpecificSettings/DynamicsBased/hooks'
import { IntegrationServiceId } from '../../../../common/integrations'
import { type CrmIntegrationSettings, type CrmSettingsProviderProps } from './types'

const makeDynamicsBasedProvider = (serviceId: IntegrationServiceId): FC<CrmSettingsProviderProps> => {
  const Provider: FC<CrmSettingsProviderProps> = ({ children }) => {
    const contact = useDynamicsBasedContactSync(serviceId)

    const settings: CrmIntegrationSettings = {
      contactSync: contact.autoSync ?? false,
      calendarSync: false,
      isSyncDisabled: contact.isSyncDisabled,
      isFetching: contact.isFetching,
      isSaving: contact.isSaving,
      save: async (patch) => {
        if (patch.contactSync !== undefined) {
          await contact.saveAutoSync(patch.contactSync)
        }
      },
    }

    return <>{children(settings)}</>
  }

  Provider.displayName = `${serviceId}CrmSettingsProvider`
  return Provider
}

export const DynamicsCrmSettingsProvider = makeDynamicsBasedProvider(IntegrationServiceId.DYNAMICS)
export const ElementsCrmSettingsProvider = makeDynamicsBasedProvider(IntegrationServiceId.ELEMENTS)
export const EngageCrmSettingsProvider = makeDynamicsBasedProvider(IntegrationServiceId.ENGAGE)
export const BlackDiamondCrmSettingsProvider = makeDynamicsBasedProvider(IntegrationServiceId.BLACK_DIAMOND)
